import React, { Component } from 'react';
import { API_ENDPOINT, JOURNAL_DASHBOARD } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';
import viewIcon from '../../../assets/svg/eye.svg'
import addIcon from '../../../assets/svg/add-icon-v2.svg';

import {
	updateParamsHelper,
	getParamsFromURL,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import { Button } from 'reactstrap';

export default class JournalTemplatesModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			journalFormBuilder: false,
			preview: false,
			total: 0,
			params: {
				entries: 10,
				page: 0,
				sortField: 'tsCreatedAt',
				sortType: -1,
				filter: '',
			},
			filter: null,
			loading: true,
			journalTemplates: [],
			error: null,
			modified: 'Not modified'.translate(this.props.lang),
			journalSSOToken: null,
		};
	}


	get = async () => {
		this.setState({
			loading: true,
			journalTemplates: [],
			modified: 'Not modified'.translate(this.props.lang),
		});

		const professionListForSelectedClinic = this.props.uData.profession[this.props.selectedGroup] || [];

		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journalTemplates/get`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
					body: JSON.stringify({
						groupAlias: localStorage.getItem('groupAlias'),
						groupId: this.props.selectedGroup || null,
						departmentId: this.props.selectedClinic || null,
						total: this.state.total,
						entries: this.state.params?.entries,
						page: this.state.params?.page,
						sortField: this.state.params?.sortField,
						sortType: this.state.params?.sortType,
						filter: this.state.params?.filter,
						isActive: true,
						professions: professionListForSelectedClinic,
						...(this.props.filterProfessionsByGroup ? { filterProfessionsByGroup: this.props.filterProfessionsByGroup } : {}),
						...(this.props.filterHeadlineTitles ? { headlineTitles: this.props.headlineTitles?.length > 0 ? this.props.headlineTitles : ['empty-list-will-never-show-any-template'] } : {})
					}),
				}
			);

			const { data } = await response.json();

			if (data?.items) {
				const newState = {
					loading: false,
					journalTemplates: data.items,
					total: data.total,
				};

				if (data.tsModified) {
					const modified = this.props.getStringDateTs?.(
						data.tsModified,
						this.props.dateFormat
					);
					if (modified) newState.modified = modified.translate(this.props.lang);
				}

				this.setState(newState);
			} else {
				const errState = {
					loading: false,
					modified: 'Not modified'.translate(this.props.lang),
				};

				if (data?.error) {
					errState.error = data.error;
				}

				this.setState(errState);
			}
		} catch (err) {
			this.setState({
				loading: false,
				error: err?.message || 'Error fetching journal templates',
			});
		}
	};


	getJournalSSOToken = async (type = "notes") => {
		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journal/getJournalTokenSSO`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${localStorage.getItem("authToken")}`,
					},
					body: JSON.stringify({ type, groupId: this.props.selectedGroup || null }),
				}
			);

			const data = await response.json();

			if (!response.ok || data?.error) {
				throw new Error(data?.error || "SSO token error");
			}

			return data;
		} catch (err) {
			console.error("SSO token fetch error", err);
			return null;
		}
	};

	componentDidMount() {
		window.addEventListener("message", this.handleIframeReady);
		window.addEventListener("message", this.handleIframeCloseModal);

		const urlParams = getParamsFromURL();

		const newParams = {
			...this.state.params,
			entries: urlParams.entries,
			filter: urlParams.filter,
		};

		this.setState({ params: newParams }, () => {
			if (this.props.journalTemplates) {
				this.setState({
					loading: false,
					journalTemplates: this.props.journalTemplates,
				});
			} else {
				// this.setState({loading: false, journalTemplates: [DEFAULT_TEMPLATE_OBJECT_DELETE_LATER]}) // DELETE THIS LATER
				this.get();
			}
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.patientId !== this.props.patientId ||
			prevProps._groupId !== this.props._groupId ||
			prevProps.view !== this.props.view ||
			prevProps.selectedClinic !== this.props.selectedClinic
		) {
			this.setState({
				loading: true,
				journalTemplates: [],
				modified: 'Not modified'.translate(this.props.lang),
			});

			this.get();
		}
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.handleIframeReady);
		window.removeEventListener("message", this.handleIframeCloseModal);
	}

	// always copy - paste these updateSort, updateParams, updateMultipleParams
	updateSort = (field, type) => {
		updateParamsHelper(this, { sortField: field, sortType: type });
	};

	updateParams = (name, value, restart = false) => {
		updateParamsHelper(this, { [name]: value }, restart);
	};

	updateMultipleParams = (fields, restart = false) => {
		updateParamsHelper(this, fields, restart);
	};

	handleIframeReady = (event) => {
		// if (event.origin !== JOURNAL_DASHBOARD) return;
		if (event.data.type === "IFRAME_READY_V1_JOURNAL_TEMPLATES_BUILDER") {
			const iframe = document.getElementById("journalTemplatesModalIframe");
			if (!iframe || !iframe.contentWindow) return;

			const lang = this.props?.lang || "en";
			const countryTwoLetter = this.props?.countryTwoLetter || localStorage.getItem('countryTwoLetter');
			const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);
			const department = this.props.selectedClinic;
			const journalClinicId = clinic?.journalCuroflow?.clinicId;
			const journalDoctorId = this.props.uData?.journalCuroflow?.[String(this.props.selectedGroup)]?.id;
			const journalPatientId = this.props.patient?.journalId;

			const payload = { type: "APP_DATA", payload: { clinicId: journalClinicId, doctorId: journalDoctorId, patientId: journalPatientId, departmentId: department, lang: lang, countryTwoLetter: countryTwoLetter } };
			iframe.contentWindow.postMessage(payload, `${JOURNAL_DASHBOARD}`);
		}
	};

	handleIframeCloseModal = (event) => {
		// if (event.origin !== JOURNAL_DASHBOARD) return;
		if (event.data.type === "IFRAME_CLOSE_V1_JOURNAL_NOTES_JOURNAL_TEMPLATES_MODAL") {
			this.closeModal();
			this.get();
		}
	}

	closeModal = () => {
		this.setState({ journalFormBuilder: null })
	}

	render() {
		let params = this.state.params;

		return (
			<PreviewModal
				lang={this.props.lang}
				isOpen={this.props.isOpen}
				toggle={() => this.props.closeModal()}
				className={"modal-xl"}
			>
				<div className='panel-header'>
					{this.props.customRenderAboveList ? (
						this.props.customRenderAboveList
					) : (
						<h5 className='component-header'>
							{'Journal Templates'.translate(this.props.lang)}
						</h5>
					)}
				</div>

				{/* Journal Templates List */}
				<ListBuilder
					lang={this.props.lang}
					loading={this.state.loading}
					total={this.state.total}
					hideEntries={false}
					showNumeration={false}
					fields={[
						{
							type: 'text',
							name: 'name',
							label: 'Name'.translate(this.props.lang),
						},
						// {
						// 	type: 'text',
						// 	name: 'templateType',
						// 	label: 'Template Type'.translate(this.props.lang),
						// },
						{
							type: 'date',
							name: 'createdAt',
							label: 'Created at'.translate(this.props.lang),
						}
					]}
					items={this.state.journalTemplates.map((item) => {
						return {
							...item,
						};
					})}
					actions={[
						{
							component: (
								<Button color='primary'>{"Select".translate(this.props.lang)}</Button>
							),
							onClick: (item) => {
								// this.setState({ journalFormBuilder: item });
								this.props.onSelect(item);
								this.props.closeModal();
							},
						},
					]}
					rawItems={this.state.items}
					params={params}
					sortField={params.sortField}
					sortType={params.sortType}
					updateSort={this.updateSort}
					updateParams={this.updateParams}
					updateMultipleParams={this.updateMultipleParams}
				></ListBuilder>

				{/* <PreviewModal
					lang={this.props.lang}
					isOpen={this.state.journalFormBuilder}
					toggle={() => this.closeModal()}
					className={"modal-xxxl"}
				>
					{this.state.journalFormBuilder && (
						<iframe
							id="journalTemplatesModalIframe"
							src={`${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilder?._id}/new`}
							style={{ width: '100%', height: '1000px', border: '1px solid #fff' }}
						/>
					)}
				</PreviewModal> */}
			</PreviewModal>
		)
	}
}